module.exports = __webpack_public_path__ + "static/media/dietyFizz project final.d2863461.jpg";